import React, { Component } from 'react';

// Components
import StatusSelector from "../../../components/common/StatusSelector";

class WarehouseDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            warehouse_code: '',
            name: '',
            comments: '',
            address: ''
        }
    }
    componentDidMount() {
        this.setWarehouseState();
        this.props.onRef(this);
    }
    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    onChangeInput = (inputName, inputValue) => {
        this.setState({
            [inputName]: inputValue
        }, this.validateWarehouse);
    };
    setWarehouseState = (warehouse) => {
        this.setState({
            warehouse_code: this.props.warehouse.get('warehouse_code'),
            name: this.props.warehouse.get('name'),
            comments: this.props.warehouse.get('comments') || '',
            address: this.props.warehouse.get('address')
        }, () => this.validateWarehouse);
    };
    validateWarehouse = () => {
        if (this.state.name !== '') {
            this.props.canSubmit(true);
        } else {
            this.props.canSubmit(false);
        }
    };
    updateWarehouse = () => {
        this.props.updateWarehouse(this.props.warehouse.get('_id'), {
            name: this.state.name,
            comments: this.state.comments,
            address: this.state.address
        });
    };

    render() {
        const { mode, warehouse } = this.props;
        let formBody;
        let statusColor = '', statusText = '';

        switch (warehouse.get('status')) {
            case 'active':
                statusColor = 'primary';
                statusText = 'Activo';
                break;
            case 'inactive':
                statusColor = 'danger';
                statusText = 'Inactivo';
                break;
            default:
                break;
        }

        switch (mode) {
            case 'view':
                formBody = (
                    <div>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Código de Almacén *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={this.state.warehouse_code}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-3 ml-auto">
                                <label>Estado</label>
                                <div className="row">
                                    <div className="col-6">
                                        <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                    </div>
                                    <div className="col-auto d-flex align-items-center" style={{ paddingLeft: 0 }} >
                                        <StatusSelector
                                            statusObject={warehouse}
                                            statusOptions={['active', 'inactive']}
                                            changeStatus={this.props.changeWarehouseStatus}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Nombre *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={this.state.name}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Comentarios</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={this.state.comments}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Dirección</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={this.state.address}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                );
                break;
            case 'edit':
                formBody = (
                    <div>
                        <div className="row">
                            <div className="col-3">
                                <div className="form-group">
                                    <label>Código de Almacén *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={this.state.warehouse_code}
                                        onChange={ (event) => this.onChangeInput('warehouse_code', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-3 ml-auto">
                                <label>Estado</label>
                                <div className="row">
                                    <div className="col-6">
                                        <span className={ 'status-label label-' + statusColor } >{ statusText }</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <div className="form-group">
                                    <label>Nombre *</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={this.state.name}
                                        onChange={ (event) => this.onChangeInput('name', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Comentarios</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={this.state.comments}
                                        onChange={ (event) => this.onChangeInput('comments', event.target.value) }
                                    />
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label>Dirección</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        value={this.state.address}
                                        onChange={ (event) => this.onChangeInput('address', event.target.value) }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                );
                break;
            default:
                formBody = null;
                break;
        }
        
        return formBody;
    }
}

export default WarehouseDetail;



// WEBPACK FOOTER //
// ./src/containers/configuration/warehouses/WarehouseDetail.js